export const BLACK_BASE = "#000";

export const TEXT_COLORS = [
  "#3A1F8C",
  "#A84C00",
  "#8B7500",
  "#7B0099",
  "#006B3D",
];
export const HIGHLIGHT_COLORS = [
  "#C5C5FF",
  "#FFD1A3",
  "#FFEB80",
  "#F0B3FF",
  "#B3FFD9",
];
